export const BLOCK_ROOM = "block room";
export const NEW_BOOKING = "new booking";
export const BOOKING_DETAILS = "booking details";
export const CONVERSATION_BOOKING_DETAILS = "conversation booking details";
export const EDIT_INDIVIDUAL_ROOM = "edit individual room";
export const ROOM_UPDATED = "room updated";
export const BOOKED_ROOM_REMOVED = "booked room removed";
export const RELOAD_CALENDAR = "reload calendar";
export const BOOKED_ROOM_SWITCHED = "booked room switched";
export const RELOAD_CALENDAR_CELLS = "reload calendar cells";
export const RELOAD_BOOKING = "reload booking";
export const SHOW_ALERT_REQUESTED = "show alert requested";
export const SHOW_BOOKING_SIDE_PANEL = "show booking side panel";
export const NEW_BOOKING_HEADER = "new booking header";
export const OPEN_CLIENT_MODAL = "open client modal";
export const OPEN_SWITCH_ROOM_MODAL = "open switch room modal";
export const OPEN_TRIAL_EXPIRED_MODAL = "open trial expired modal";
export const OPEN_SMART_PRICING_SUBSCRIBE_MODAL =
  "open smart pricing subscribe modal";
export const SAVE_NEW_CLIENT = "save new client";
export const BOOKING_DATA_UPDATED = "booking data updated";
export const ADD_CLIENT_INFO_CLIENT_SELECTED =
  "add client info client selected";
export const BOOKING_CREATED = "booking created";
export const BOOKING_CANCELLED = "Booking Cancelled";
export const UPDATE_GUEST_COUNTRY_CODE_FORM_SET_VISIBILITY_REQUESTED =
  "set visibility of update guest country code form";
export const INVENTORY_START_DATE_CHANGED = "inventory start date changed";
export const TOGGLE_BULK_UPDATE = "toggle bulk update";
export const OPEN_SMART_PRICING_SUBSCRIBE_PREMIUM_MODAL =
  "open smart pricing subscribe premium modal";
export const SCROLL_LEFT = "scroll left";
export const SCROLL_RIGHT = "scroll right";
export const SET_INVENTORY_SCROLL = "set inventory scroll";
export const INVOICE_SEND_BY_MAIL = "invoice send by mail";
export const QUOTE_CREATED = "quote created";
export const REFRESH_INVENTORY_ROOM_CALENDAR =
  "refresh inventory room calendar";
export const OPEN_SMART_PRICING_ACTIVATION_MODAL =
  "open smart pricing activation modal";
export const OPEN_SMART_PRICING_ACTIVATE_PREMIUM_MODAL =
  "open smart pricing activate premium modal";
export const BOOKING_SIDEPANEL_CLOSED = "booking sidepanel closed";
export const BOOKING_DETAILS_SIDEPANEL_CLOSED =
  "booking details sidepanel closed";
export const QUOTE_DECLINED = "quote declined";
export const QUOTE_APPROVED = "quote approved";
export const QUOTE_DETAIL_REQUESTED = "quote detail requested";
export const BOOKING_DATES_UPDATED = "booking dates updated";
export const BOOKING_DATES_UPDATED_ERROR = "booking dates updated error";
export const SHOW_EDIT_BOOKING_DATES = "show edit booking dates";
export const CLOSE_SIDEPANEL_REQUESTED = "close sidepanel requested";
export const OPEN_RATE_PLANS_BULK_UPDATE_SIDE_PANEL =
  "open rate plans bulk update side panel";
export const LOG_REFUND_CANCELLED = "log refund cancelled";
export const LOG_REFUND_DONE = "log refund done";
export const INVOICE_CANCELLATION_ABORTED = "invoice cancellation cancelled";
export const INVOICE_CANCELLATION_DONE = "invoice cancellation done";
export const OPEN_INVENTORY_BULK_UPDATE_SIDE_PANEL =
  "open inventory bulk update side panel";
export const ROOM_CALENDARS_UPDATED = "room calendars updated";
export const MANUAL_BOOKING_PAYMENT_METHOD_FORM_FILLED =
  "manual booking payment method form filled";
export const MANUAL_BOOKING_UPDATED = "manual booking updated";
